export default __webpack_public_path__ + "static/media/rw.b876f6d9.svg";